import { defineAction } from "rd-action-creators";

export const generatePDFOfferAction = defineAction<{ clientId: string; campaignId: string }>("GENERATE PDF OFFER");
export const generatePDFOfferActionFinished = defineAction("GENERATE PDF OFFER FINISHED");
export const generatePDFOfferActionError = defineAction("GENERATE PDF OFFER ERROR");
